import type { NodeRecord, TextStyle } from '@flobi/artwork-core';

/** Object-level formatting also replaces matching rich-text overrides, preserving all others. */
export function textToolbarStyle(node: Extract<NodeRecord, { type: 'text' }>, patch: Partial<TextStyle>) {
  const keys = Object.keys(patch) as (keyof TextStyle)[];
  const hasOverrides = node.runs.some(run => keys.some(key => run.style?.[key] !== undefined));
  return {
    style: { ...node.style, ...patch },
    ...(hasOverrides ? { runs: node.runs.map(run => {
      if (!run.style) return run;
      const style = { ...run.style };
      for (const key of keys) delete style[key];
      return { ...run, style };
    }) } : {}),
  };
}
